import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export function RemindersOffBanner({ onFix }) {
  return (
    <div className="flex flex-wrap items-center gap-3 border border-[#E50000] bg-[#E50000]/10 px-4 py-3 mb-5"
      data-testid="reminders-off-banner">
      <AlertTriangle className="w-5 h-5 text-[#E50000] shrink-0" />
      <div className="flex-1 min-w-[220px] text-sm">
        <b className="text-[#E50000] uppercase tracking-wider">Convocatórias automáticas desligadas.</b>{" "}
        Os coopetidores não recebem os emails de 24h e 2h antes, e o QR não segue para o Secretário e o Capitão.
      </div>
      {onFix ? (
        <button onClick={onFix} className="kw-btn-primary !py-1.5 !px-3 text-xs" data-testid="reminders-off-fix">Ligar agora</button>
      ) : (
        <Link to="/settings" className="kw-btn-primary !py-1.5 !px-3 text-xs" data-testid="reminders-off-link">Ligar na Configuração</Link>
      )}
    </div>
  );
}
